module.exports = __webpack_public_path__ + "static/media/SafariLandingPage.83b48ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SafariLandingPage.png
// module id = 756
// module chunks = 0